export default __webpack_public_path__ + "static/media/logo-twilio.0a5e2a19.png";